import React, { useContext, useState, useEffect } from "react";
import { UserContext, BaseUrl } from "../../App.js";
import classes from "./UserInfo.module.css";

const UserLogo = (props) => {
  const [user] = useContext(UserContext);
  const [name, setName] = useState("");

  useEffect(() => {
    if (localStorage.getItem("userName") && !user.accesstoken) setName("GUEST");
    else if (localStorage.getItem("userName"))
      setName(localStorage.getItem("userName"));
    else setName("GUEST");

    if (user.accesstoken && !localStorage.getItem("userName"))
      props.logOutCallback();
  }, [user.accesstoken]);

  return (
    <div className={classes.Header_img}>
      <img
        className={classes.LogoImg}
        src={`https://userspictures.s3.us-east-2.amazonaws.com/${localStorage.getItem(
          "userImage"
        )}`}
      />
    </div>
  );
};
export default React.memo(UserLogo);
